export const initialState = {
  getConfig: {
    loading: false,
    success: false,
    error: false,
    data: {},
  },
};
